<template>
  <auth-layout
    title="Activate your account"
    subtitle="Enter the activation code we sent to your email to finish setting up your account."
    icon="mark_email_read"
  >
    <form
      class="c-activate"
      novalidate
      @submit.prevent="validateForm"
    >
      <div
        v-if="activationError"
        class="ui-alert ui-alert--danger"
        role="alert"
      >
        <app-icon name="error" />
        <span>{{ activationError }}</span>
      </div>

      <div
        v-if="email"
        class="ui-alert ui-alert--info"
      >
        <app-icon name="info" />
        <span>Code sent to <strong>{{ email }}</strong>. Need a new one? Sign in again to get a fresh code.</span>
      </div>

      <div :class="['ui-field', { 'ui-field--invalid': $v.activationToken.$error }]">
        <label
          class="ui-field__label"
          for="activation-token"
        >Activation code</label>
        <div class="ui-field__control">
          <app-icon
            class="ui-field__icon"
            name="key"
          />
          <input
            id="activation-token"
            v-model.trim="activationToken"
            v-focus
            class="ui-field__input c-activate__code"
            type="text"
            name="activationToken"
            placeholder="Enter code"
            autocomplete="one-time-code"
            :aria-invalid="$v.activationToken.$error"
          >
        </div>
        <span
          v-if="$v.activationToken.$error"
          class="ui-field__error"
        >Activation code is required</span>
      </div>

      <div class="c-activate__actions">
        <button
          type="button"
          class="ui-btn ui-btn--secondary ui-btn--lg"
          @click="goToLogin"
        >
          <app-icon name="arrow_back" />
          Back to sign in
        </button>
        <button
          type="submit"
          :class="['ui-btn ui-btn--primary ui-btn--lg c-activate__submit', { 'ui-btn--loading': isSubmitting }]"
          :disabled="isSubmitting"
        >
          Activate
        </button>
      </div>
    </form>
  </auth-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AuthLayout from "../../shared/auth-layout/AuthLayout";
import AppIcon from "../../shared/app-icon/AppIcon";
import { validationBaseMixin } from '../../mixins/ValidationBaseMixin'
import {
  required,
} from 'vuelidate/lib/validators'

export default {
  components: {
    AuthLayout,
    AppIcon,
  },
  mixins: [validationBaseMixin],
  data: () => {
    return {
      email: null,
      activationToken: null,
      isSubmitting: false,
    }
  },
  validations: {
    activationToken: {
      required,
      minLength: 4,
      maxLength: 4
    }
  },
  computed: {
    ...mapState('account', ['activationError'])
  },
  created() {
    this.email = this.$route.query.email
    this.activationToken = this.$route.query.activationToken
  },
  methods: {
    ...mapActions('account', ['handleActivation']),

    validateForm () {
      this.$v.$touch();

      if (!this.$v.$invalid && !this.isSubmitting) {
        this.activate()
      }
    },

    goToLogin () {
      this.$router.push({ name: 'login' });
    },

    async activate () {
      this.isSubmitting = true

      try {
        await this.handleActivation({ email: this.email, activationToken: this.activationToken })
        this.$router.push({ name: "websites" });
      } catch (error) {
        console.log('Activation error', error)
      } finally {
        this.isSubmitting = false
      }

    }
  }
}
</script>

<style lang="scss" scoped>
  .c-activate {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .c-activate__code {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 0.2em;

    &::placeholder {
      font-size: 15px;
      font-weight: 400;
      letter-spacing: normal;
    }
  }

  .c-activate__actions {
    display: flex;
    gap: 12px;
    margin-top: 8px;
  }

  .c-activate__submit {
    flex: 1;
  }
</style>
